import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class FinancialConfigQueryCriteriaClass extends BaseCriteriaModel {
  //for hdr
  namespace?: Optional<string> = Optional.empty();
  app_id?: Optional<string> = Optional.empty();
  config_type?: Optional<string> = Optional.empty();
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  descr?: Optional<string> = Optional.empty();
  comp_guid?: Optional<string> = Optional.empty();
  branch_guid?: Optional<string> = Optional.empty();
  glcode_guid?: Optional<string> = Optional.empty();
  payment_type?: Optional<string> = Optional.empty();
  payment_code?: Optional<string> = Optional.empty();

  //for extension
  hdr_guid?: Optional<string> = Optional.empty();
  line_guid?: Optional<string> = Optional.empty();
  ext_type?: Optional<string> = Optional.empty();
  ext_code?: Optional<string> = Optional.empty();
  ext_option?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
}

export class FinancialConfigCriteriaModelQuery {
  query = '';

  constructor(financialConfigCriteriaModel: FinancialConfigQueryCriteriaClass) {

    if (!financialConfigCriteriaModel) {
      return;
    }

    this.query += financialConfigCriteriaModel.namespace.filter(x => x !== '').map(x => '&namespace=' + x).orElse('');
    this.query += financialConfigCriteriaModel.app_id.filter(x => x !== '').map(x => '&app_id=' + x).orElse('');
    this.query += financialConfigCriteriaModel.config_type.filter(x => x !== '').map(x => '&config_type=' + x).orElse('');
    this.query += financialConfigCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += financialConfigCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += financialConfigCriteriaModel.descr.filter(x => x !== '').map(x => '&descr=' + x).orElse('');
    this.query += financialConfigCriteriaModel.comp_guid.filter(x => x !== '').map(x => '&comp_guid=' + x).orElse('');
    this.query += financialConfigCriteriaModel.branch_guid.filter(x => x !== '').map(x => '&branch_guid=' + x).orElse('');
    this.query += financialConfigCriteriaModel.glcode_guid.filter(x => x !== '').map(x => '&glcode_guid=' + x).orElse('');
    this.query += financialConfigCriteriaModel.payment_type.filter(x => x !== '').map(x => '&payment_type=' + x).orElse('');
    this.query += financialConfigCriteriaModel.payment_code.filter(x => x !== '').map(x => '&payment_code=' + x).orElse('');

    this.query += financialConfigCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += financialConfigCriteriaModel.line_guid.filter(x => x !== '').map(x => '&line_guid=' + x).orElse('');
    this.query += financialConfigCriteriaModel.ext_type.filter(x => x !== '').map(x => '&ext_type=' + x).orElse('');
    this.query += financialConfigCriteriaModel.ext_code.filter(x => x !== '').map(x => '&ext_code=' + x).orElse('');
    this.query += financialConfigCriteriaModel.ext_option.filter(x => x !== '').map(x => '&ext_option=' + x).orElse('');
    this.query += financialConfigCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += financialConfigCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += financialConfigCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += financialConfigCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');


    this.query += '&status=' + financialConfigCriteriaModel.status;
    this.query += '&orderBy=' + financialConfigCriteriaModel.orderBy;
    this.query += '&order=' + financialConfigCriteriaModel.order;
    this.query += '&offset=' + financialConfigCriteriaModel.offset + '&limit=' + financialConfigCriteriaModel.limit;
  }
}
